var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-audio card-loader border-0 d-flex mb-3"},[_c('div',{staticClass:"bg-white d-flex align-items-center justify-content-center"},[_c('ProductIcon',{attrs:{"productType":_vm.mediaTypeIcon,"size":"2x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }